import BannersStore from "./BannersStore";
import HomePageBannersConfiguration from "./HomePageBannersConfiguration";

const bannersStore = new BannersStore();

const homePageBannersConfiguration = new HomePageBannersConfiguration(bannersStore);

export default homePageBannersConfiguration;
